import { ChangeDetectionStrategy, Component, inject, input, InputSignal } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';

import { DashboardInterventionEntitiesByStatus } from '@connect-services/client/components/field-intervention-information/field-intervention-operator-or-status-metrics/field-intervention-operator-or-status-metrics.component';
import { FieldInterventionStatusComponent } from '@connect-services/client/components/field-intervention-status/field-intervention-status.component';
import { FieldInterventionService } from '@connect-services/client/services/field-intervention.service';
import { RessourcesModule } from '@ressources/client/ressources.module';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [FieldInterventionStatusComponent, RessourcesModule],
    selector: 'app-field-intervention-entity',
    styleUrl: '../field-intervention-operator-or-status-metrics.component.scss',
    templateUrl: './field-intervention-entity.component.html',
})
export class FieldInterventionEntityComponent {
    public readonly entity: InputSignal<DashboardInterventionEntitiesByStatus> =
        input.required<DashboardInterventionEntitiesByStatus>();

    protected readonly entityStatuses = FieldInterventionService.entityStatuses;

    private readonly translocoService = inject(TranslocoService);

    protected getEntityStatus(): string {
        const statusProperties = this.entityStatuses[this.entity()!.status!];

        if (!this.entity().status || !this.entity()) {
            return '';
        }

        return this.translocoService.translate(statusProperties);
    }
}
